import { CampaignGroupIdSchema as n } from "@hprofits/shared";
import { PrivilegeEnum as a } from "@hprofits/shared/auth";
import { z as i } from "zod";
import "../common/acl-view.js";
import { ocPrivate as t } from "../common/auth/procedure-builders.js";
import { createCreationResultSchema as p } from "../common/creation-result.js";
import "../common/owner.js";
import { CampaignGroupIdParamSchema as r, ForceActionParamSchema as o } from "../common/params.js";
import "../common/errors/constants.js";
import { inUseError as s, notFoundError as m, alreadyExistsError as u } from "../common/errors/contract.js";
import "../common/errors/schemas.js";
import "../swagger/security.js";
import { SwaggerTags as e } from "../swagger/tags.js";
import { CampaignCommonMutationSchema as c, CampaignAdminMutationSchema as d, RenameCampaignSchema as g, CreateCampaignSchema as h, CampaignStatisticsSchema as C, CampaignSchema as S, CampaignListQuerySchema as A, CampaignListSchema as I } from "./schemas.js";
const f = i.union([
  c.unwrap().extend({
    campaignId: r.shape.campaignId
  }),
  d.unwrap().extend({
    campaignId: r.shape.campaignId
  })
]), U = {
  campaign: {
    /**
     * List campaigns
     *
     * Returns a paginated list of campaigns filtered by id or name, owner,
     * recent-creation window (last 7 days), and ad unit types.
     */
    findAll: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/campaigns",
      summary: "List campaigns",
      description: "Returns a paginated list of campaigns filtered by id or name (comma-separated terms), owner, recent-creation window (last 7 days), and ad unit types.",
      tags: [e.CAMPAIGNS.name]
    }).input(A).output(I).errors({}),
    /**
     * Get a campaign by ID
     */
    findOne: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/campaigns/{campaignId}",
      summary: "Get a campaign by ID",
      tags: [e.CAMPAIGNS.name]
    }).input(r).output(S).errors({
      ...m("Campaign not found")
    }),
    /**
     * Get campaign statistics data for Campaign Statistics block
     */
    getStatistics: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/campaigns/{campaignId}/statistics",
      summary: "Get campaign statistics data",
      description: "Returns target groups, creative groups metadata, and ad groups with pricing rules for Campaign Statistics block",
      tags: [e.CAMPAIGNS.name]
    }).input(r).output(C).errors({
      ...m("Campaign not found")
    }),
    /**
     * Create a new campaign
     */
    create: t([a.WriteAdvert]).route({
      method: "POST",
      path: "/campaigns",
      summary: "Create a campaign",
      tags: [e.CAMPAIGNS.name],
      successStatus: 201
    }).input(h).output(p(n)).errors({}),
    /**
     * Update a campaign
     */
    update: t([a.WriteAdvert]).route({
      method: "PUT",
      path: "/campaigns/{campaignId}",
      summary: "Update a campaign",
      tags: [e.CAMPAIGNS.name],
      successStatus: 204
    }).input(f).output(i.void()).errors({
      ...m("Campaign not found")
    }),
    /**
     * Rename a campaign
     */
    rename: t([a.WriteAdvert]).route({
      method: "PATCH",
      path: "/campaigns/{campaignId}",
      summary: "Rename a campaign",
      tags: [e.CAMPAIGNS.name],
      successStatus: 204
    }).input(
      g.unwrap().extend({
        campaignId: r.shape.campaignId
      })
    ).output(i.void()).errors({
      ...m("Campaign not found"),
      ...u("Campaign with this name already exists")
    }),
    /**
     * Delete a campaign
     */
    remove: t([a.WriteAdvert]).route({
      method: "DELETE",
      path: "/campaigns/{campaignId}",
      summary: "Delete a campaign",
      tags: [e.CAMPAIGNS.name],
      successStatus: 204,
      inputStructure: "detailed"
    }).input(
      i.object({
        params: r,
        query: o
      })
    ).output(i.void()).errors({
      ...m("Campaign not found"),
      ...s("Campaign is used in target groups or ad groups")
    })
  }
};
export {
  U as campaignContract
};
//# sourceMappingURL=contract.js.map
